// Returns null (not "") when the input is unparseable so callers can drop
// trailing separators rather than rendering e.g. "3 messages · ".
export function formatRelativeTime(iso: string, locale: string): string | null {
  const updated = new Date(iso).getTime()
  if (Number.isNaN(updated)) return null
  const diffSec = Math.round((updated - Date.now()) / 1000)
  const absSec = Math.abs(diffSec)
  // Intl.RelativeTimeFormat throws RangeError on malformed locale tags
  // (empty string, BCP-47 violations, etc.). Fall back to the runtime default
  // so a bad i18n.language can't crash callers that render this output.
  let fmt: Intl.RelativeTimeFormat
  try {
    fmt = new Intl.RelativeTimeFormat(locale || undefined, { numeric: "auto" })
  } catch {
    fmt = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" })
  }
  if (absSec < 60) return fmt.format(diffSec, "second")
  const diffMin = Math.round(diffSec / 60)
  if (Math.abs(diffMin) < 60) return fmt.format(diffMin, "minute")
  const diffHr = Math.round(diffMin / 60)
  if (Math.abs(diffHr) < 24) return fmt.format(diffHr, "hour")
  const diffDay = Math.round(diffHr / 24)
  if (Math.abs(diffDay) < 7) return fmt.format(diffDay, "day")
  return fmt.format(Math.round(diffDay / 7), "week")
}
